export const attribute = (l10n = {}, it = {}, enchant = 0) => {
    let enchantOptionData = it.enchantBonusList ? it.enchantBonusList[enchant] : null;
    let invokeOptions = it.invoke ? [it.invoke] : [];

    if (enchantOptionData) {
        enchantOptionData.map((eit) => {
            let match = false;
            for (let i = 0; i < it.optionList.length; i++) {
                const el = it.optionList[i];
                if (el.type === eit.type) {
                    el.displayValue = `
                    ${el.displayValue}&nbsp;
                    <em>
                        ${eit.prefixDescription ? eit.prefixDescription : ''}
                        ${!!eit.value && eit.value !== '0' ? eit.value : ''}
                    </em>`;
                    match = true;
                    break;
                }
            }

            if (!match && eit.displayValue) {
                eit.displayValue = `<em>${eit.displayValue}</em>`;
                if (eit.invokeEffectCategory !== undefined) {
                    invokeOptions.push(eit);
                } else {
                    it.optionList.push(eit);
                }
            }
        });
    }

    return `
    <section class="attribute">
        <header>
            <h3>${l10n['item.itemInfo']}</h3>
            <button class="btn-folder is-active"></button>
        </header>
        <article class="is-active">
            <ul>
                ${
                    it.itemClassList?.length < 1
                        ? ``
                        : `
                <li>
                    <div class="key">${l10n['item.class']}</div>
                    <div class="value">${it.itemClassList?.map((cls) => cls.className).join(' / ')}</div>
                </li>
                `
                }
                ${
                    it.optionList?.length < 1
                        ? ``
                        : `
                <li>
                    <div class="key">${l10n['item.option']}</div>
                    <div class="value">
                        ${it.optionList?.map((op) => `<p data-type="${op.type}">${op.displayValue}</p>`).join('') || ''}
                    </div>
                </li>
                `
                }
                ${
                    invokeOptions.length < 1
                        ? ``
                        : `
                <li>
                    <div class="key">${l10n['item.trigger']}</div>
                    <div class="value">
                    ${invokeOptions
                        .map((inv) => {
                            if (inv.invokeSpellId) {
                                return `
                                    <button data-detailshow="spell_${inv.invokeSpellId}">
                                        ${inv.displayValue}
                                    </button>
                                `;
                            } else {
                                return inv.displayValue;
                            }
                        })
                        .join('')}
                    </div>
                </li>
                `
                }
                ${
                    it.socketCount < 1
                        ? ``
                        : `
                <li>
                    <div class="key">${l10n['item.imbueProperty']}</div>
                    <div class="value">${(() => {
                        let sockets = '';
                        for (let i = 0; i < it.socketCount; i++) {
                            sockets += '<span class="value-elemental"></span>';
                        }
                        return sockets;
                    })()}</div>
                </li>
                `
                }
                ${  
                    !it.tier
                        ? `` 
                        : `
                <li>
                    <div class="key">${l10n['item.tier']}</div>
                    <div class="value">${it.tier}</div>
                </li>
                `
                }
                ${
                    !it.material
                        ? ``
                        : `
                <li>
                    <div class="key">${l10n['item.material']}</div>
                    <div class="value">${it.material}</div>
                </li>
                `
                }
                <li>
                    <div class="key">${l10n['item.weight']}</div>
                    <div class="value">${it.weight ? parseFloat(it.weight / 100).toFixed(2) : '0.00'}</div>
                </li>
                ${
                    !it.storyDescription
                        ? ``
                        : `
                <li>
                    <div class="key">${l10n['item.description']}</div>
                    <div class="value">${it.storyDescription?.replace(/\n/gi, '<br>')}</div>
                </li>
                `
                }
            </ul>
        </article>
    </section>`;
};
